module.exports = __webpack_public_path__ + "static/media/Assigned-in-UAE-2.a75bd462.jpg";